import { rem, Anchor, Button, Checkbox, Input, InputWrapper, Select, TextInput, Modal } from "@mantine/core";
import classesAnchor from "../../dist/assets/baseTheme/Anchor.module.css";
import classesSelect from "../../dist/assets/baseTheme/Select.module.css";
import classesInput from "../../dist/assets/baseTheme/Input.module.css";
import classesTextInput from "../../dist/assets/baseTheme/TextInput.module.css";
import classesCheckbox from "../../dist/assets/baseTheme/Checkbox.module.css";
import classesDatePickerInput from "../../dist/assets/baseTheme/DatePickerInput.module.css";
import { generateColors } from "@mantine/colors-generator";
import { prefixCSSVars } from "../lib";
import colors from "../colour-constants-baas";
export const resolver = ({ other: { headerNavBg, headerNavColor, mainColor, brandColor, splashColor } })=>({
        variables: {
            '--header-nav-bg': headerNavBg,
            '--header-nav-color': headerNavColor,
            '--main-color': mainColor,
            '--brand-color': brandColor,
            '--splash-color': splashColor,
            ...prefixCSSVars(colors)
        },
        dark: {},
        light: {}
    });
const BRAND_COLOR = '#827127';
const baseTheme = ({ fontFamily, themeOverrides })=>{
    const brandPrimaryColor = (themeOverrides == null ? void 0 : themeOverrides.brandColor) || BRAND_COLOR;
    var _themeOverrides_brandColor;
    return {
        other: {
            headerNavBg: (themeOverrides == null ? void 0 : themeOverrides.headerNavBg) || '#fff',
            headerNavColor: (themeOverrides == null ? void 0 : themeOverrides.headerNavColor) || '#fff',
            mainColor: (themeOverrides == null ? void 0 : themeOverrides.mainColor) || '#FFF',
            brandColor: (themeOverrides == null ? void 0 : themeOverrides.brandColor) || '#D3DAE1',
            splashColor: (themeOverrides == null ? void 0 : themeOverrides.splashColor) || '#858B91',
            brandCollinsons: brandPrimaryColor
        },
        colors: {
            brandCollinsons: generateColors((themeOverrides == null ? void 0 : themeOverrides.brandColor) || BRAND_COLOR)
        },
        primaryColor: 'brandCollinsons',
        primaryShade: 9,
        defaultRadius: 4,
        fontFamily,
        fontFamilyMonospace: fontFamily,
        headings: {
            fontFamily
        },
        lineHeights: {
            xs: '1.4',
            sm: '1.45',
            md: '1.55',
            lg: '1.6',
            xl: '1.65'
        },
        fontSizes: {
            xs: rem(12),
            sm: rem(14),
            md: rem(16),
            lg: rem(18),
            xl: rem(20),
            xxl: rem(32)
        },
        components: {
            InputWrapper: InputWrapper.extend({
                styles: ({ colors })=>({
                        label: {
                            fontSize: '18px',
                            color: colors.dark[6]
                        },
                        required: {
                            color: colors.red[6]
                        },
                        error: {
                            color: colors.red[6]
                        }
                    })
            }),
            Anchor: Anchor.extend({
                classNames: ()=>({
                        root: classesAnchor.root
                    })
            }),
            Modal: Modal.extend({
                styles: ({ colors })=>({
                        close: {
                            color: colors.dark[6]
                        },
                        header: {
                            minHeight: 'auto'
                        },
                        content: {
                            minHeight: 'auto'
                        }
                    })
            }),
            Select: Select.extend({
                classNames: ()=>({
                        input: classesSelect.input
                    })
            }),
            Input: Input.extend({
                classNames: ()=>({
                        input: classesInput.input,
                        label: classesInput.label,
                        invalid: classesInput.invalid
                    }),
                vars: ()=>({
                        wrapper: {
                            '--input-height': rem(50),
                            '--input-fz': '1.2rem'
                        }
                    })
            }),
            Button: Button.extend({
                defaultProps: {
                    color: (_themeOverrides_brandColor = themeOverrides == null ? void 0 : themeOverrides.brandColor) != null ? _themeOverrides_brandColor : '#000'
                },
                vars: ()=>{
                    var _themeOverrides_brandColor;
                    return {
                        root: {
                            '--brand-color': (_themeOverrides_brandColor = themeOverrides == null ? void 0 : themeOverrides.brandColor) != null ? _themeOverrides_brandColor : '#000',
                            '--button-height': rem(44)
                        }
                    };
                }
            }),
            TextInput: TextInput.extend({
                classNames: ()=>({
                        input: classesTextInput.input,
                        label: classesTextInput.label
                    })
            }),
            Checkbox: Checkbox.extend({
                classNames: ()=>({
                        input: classesCheckbox.input
                    })
            }),
            DatePickerInput: {
                classNames: ()=>({
                        label: classesDatePickerInput.label,
                        input: classesDatePickerInput.input
                    })
            }
        }
    };
};
export default baseTheme;
